import * as api from './commonApi'
import { default as flattenPermissions } from './flatten-permissions'

export default { ...api, flattenPermissions }
